// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const gossifleur: PokeData = {
  "id": 829,
  "name": "gossifleur",
  "height": 4,
  "weight": 22,
  "base_experience": 50,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "sing",
    "razor-leaf",
    "rapid-spin",
    "sweet-scent",
    "synthesis",
    "hyper-voice",
    "aromatherapy",
    "leaf-storm",
    "round",
    "leaf-tornado",
    "leafage"
  ],
  "moves": [
    "razor-leaf",
    "synthesis",
    "hyper-voice",
    "aromatherapy",
    "leaf-tornado",
    "vine-whip",
    "bullet-seed",
    "wood-hammer",
    "solar-beam",
    "branch-poke",
    "frenzy-plant",
    "power-whip",
    "energy-ball"
  ],
  "evolution_chain": {
    "id": 437,
    "item": null,
    "species": [
      {
        "name": "gossifleur",
        "order": 829,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "eldegoss",
        "order": 830,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 829,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 50,
    "speed": 10,
    "ability_power": 40
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
